export default __webpack_public_path__ + "static/media/callgreen.44ba3960.svg";